import React, { useState, useEffect, useRef } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import Lottie from 'react-lottie'
import animationData from '../touchAnim/touch.json'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import { ArrowRight } from '@carbon/icons-react'
import { Button } from 'carbon-components-react'

function HotspotComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback
  } = props

  const {
    ControlID,
    IsMultipleQuestion,
    DisplayType,
    Background,
    QuestionColorFill,
    AnswerColorFill,
    QuestionFontSize,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    HotSpot,
    BackgroundOverlay,
    Priority,
    SequenceHint,
    Opacity
  } = mcData

  const [hotSpotList, sethotSpotList] = useState(HotSpot)
  const [currentHotspot, setCurrentHotspot] = useState()
  const [selectionMap, setSelectionMap] = useState({})
  const [isAnimation, setIsAnimation] = useState(true)
  const [isStopped, setIsStopped] = useState(true)
  const imgRef = useRef()
  const [remainingHotspotList, setRemainingHotspotList] = useState(HotSpot)
  const [trackRemainingHotspotList, setTrackRemainingHotspotList] = useState([])
  const [hotspotSkipTracker, setHotspotSkipTracker] = useState(1)

  const updateCurrentHotspot = (update, selMap) => {
    const selectedHotspots = Object.keys(selMap)
    const selectionMapLength = selectedHotspots.length
    const remainigHotspots = hotSpotList.filter(
      (h) => !selectedHotspots.includes(h.ID)
    )
    if (update && selectionMapLength < hotSpotList.length) {
      setCurrentHotspot(remainigHotspots[0])
    }
    validateCorrectAnswer(false, selMap, remainigHotspots)
  }

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        const { selectionMap, remainingList } = defaultValue.CtlValue
        if (selectionMap && remainingList) {
          setSelectionMap(selectionMap)
          if (remainingList) {
            setCurrentHotspot(remainingList[0])
            setRemainingHotspotList(remainingList)
          } else {
            setCurrentHotspot(HotSpot[0])
            setRemainingHotspotList(HotSpot)
          }
        } else {
          setSelectionMap({})
          setCurrentHotspot(HotSpot[0])
        }
        // if (followTheFlow && currentPriority === Priority) {
        //   onPriorityChange(Priority)
        // }
      }
    } else {
      setSelectionMap({})
      setCurrentHotspot(HotSpot[0])
      setRemainingHotspotList(HotSpot)
    }
    sethotSpotList(HotSpot)
  }, [defaultValue])

  useEffect(() => {
    setTrackRemainingHotspotList(remainingHotspotList)
  }, [remainingHotspotList])
  useEffect(() => {
    if (hotspotSkipTracker > 1 && trackRemainingHotspotList.length > 1) {
      let arrayCopy = [...trackRemainingHotspotList]
      arrayCopy.push(arrayCopy.shift())
      setCurrentHotspot(arrayCopy[0])
      onAttemptChange(1)
      setTrackRemainingHotspotList(arrayCopy)
    }
  }, [hotspotSkipTracker])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (isAnimation) {
      setIsStopped(false)
      setTimeout(() => {
        setIsAnimation(false)
        setIsStopped(true)
      }, 1000)
    }
  }, [isAnimation])

  useEffect(() => {
    if (Object.keys(selectionMap).length < HotSpot.length) {
      setIsAnimation(true)
    }
  }, [selectionMap])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, selectionMap, HotSpot)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function validateCorrectOrNot() {
    let isCorrect = false
    if (isEmbeded) {
      let selectedArrayCop = []
      let selectedWrong = []
      for (const key in selectionMap) {
        if (Object.prototype.hasOwnProperty.call(selectionMap, key)) {
          const hpot = hotSpotList.find((h) => h.ID === key)
          if (hpot && selectionMap[key] === true && hpot.Score > 0) {
            selectedArrayCop.push(hpot)
          } else {
            selectedWrong.push(hpot)
          }
        }
      }
      let hotspotLengthArray = hotSpotList.filter((item) => item.Score !== 0)
      if (selectedWrong.length > 0) {
        isCorrect = false
      } else {
        if (selectedArrayCop.length === hotspotLengthArray.length) {
          isCorrect = true
        } else {
          isCorrect = false
        }
      }
    } else {
      if (Object.keys(selectionMap).length === hotSpotList.length) {
        for (const key in selectionMap) {
          if (Object.prototype.hasOwnProperty.call(selectionMap, key)) {
            const hpot = hotSpotList.find((h) => h.ID === key)
            if (hpot && selectionMap[key] === true) {
              isCorrect = true
            } else {
              isCorrect = false
              break
            }
          }
        }
      }
    }
    return isCorrect
  }

  function explanationValidation() {
    let isCorrect = validateCorrectOrNot()
    if (isCorrect) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  function validateCorrectAnswer(timerValue, selectionMapCopy, remainingList) {
    let isCorrect = false
    let totalScore = 0
    let currentScore = 0
    hotSpotList.forEach((h) => {
      totalScore += h.Score
    })
    if (isEmbeded) {
      let selectedArrayCop = []
      let selectedWrong = []
      for (const key in selectionMapCopy) {
        if (Object.prototype.hasOwnProperty.call(selectionMapCopy, key)) {
          const hpot = hotSpotList.find((h) => h.ID === key)
          if (hpot && selectionMapCopy[key] === true && hpot.Score > 0) {
            selectedArrayCop.push(hpot)
            isCorrect = true
            if (IsMultipleQuestion) {
              currentScore += hpot.Score
            } else {
              currentScore = hpot.Score
            }
          } else {
            selectedWrong.push(hpot)
            isCorrect = false
            currentScore = 0
            break
          }
        }
      }

      //Change priority value
      if (onPriorityChange && followTheFlow) {
        if (isPractice) {
          if (selectedWrong.length > 0) {
          } else {
            let hotspotLengthArray = hotSpotList.filter(
              (item) => item.Score !== 0
            )
            if (selectedArrayCop.length === hotspotLengthArray.length) {
              onPriorityChange(Priority)
            }
          }
        } else {
          let hotspotLengthArray = hotSpotList.filter(
            (item) => item.Score !== 0
          )
          if (
            Object.keys(selectionMapCopy).length >= hotspotLengthArray.length
          ) {
            onPriorityChange(Priority)
          }
        }
      }
      let hotspotLengthArray = hotSpotList.filter((item) => item.Score !== 0)
      if (selectedArrayCop.length === hotspotLengthArray.length) {
        handleSucAndFailFeedback(true)
      } else {
        if (Object.keys(selectionMapCopy).length >= hotspotLengthArray.length) {
          handleSucAndFailFeedback(false)
        }
      }
    } else {
      if (Object.keys(selectionMapCopy).length === hotSpotList.length) {
        for (const key in selectionMapCopy) {
          if (Object.prototype.hasOwnProperty.call(selectionMapCopy, key)) {
            const hpot = hotSpotList.find((h) => h.ID === key)
            if (hpot && selectionMapCopy[key] === true) {
              isCorrect = true
              if (IsMultipleQuestion) {
                currentScore += hpot.Score
              } else {
                currentScore = hpot.Score
              }
            } else {
              isCorrect = false
              currentScore = 0
              break
            }
          }
        }
      }
    }
    const controlList = {
      selectionMap: selectionMapCopy,
      remainingList: remainingList
    }
    if (isCorrect) {
      onValueChange(
        ControlID,
        controlList,
        currentScore,
        totalScore,
        '',
        timerValue
      )
    } else {
      onValueChange(
        ControlID,
        controlList,
        currentScore,
        totalScore,
        '',
        timerValue
      )
    }
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      {!isEmbeded && (
        <div className='hotspot-header-cont'>
          {currentHotspot && (
            <div className='hotspot-label-cont'>
              <p
                className='hotspot-header-label'
                style={{
                  color: QuestionColorFill,
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  backgroundColor: QuestionFillColor
                }}
              >
                {currentHotspot && currentHotspot.Question}
              </p>
              {IsMultipleQuestion && (
                <Button
                  className='smart-label-skip-icon'
                  hasIconOnly
                  iconDescription='Skip'
                  renderIcon={ArrowRight}
                  tooltipAlignment='center'
                  tooltipPosition='bottom'
                  onClick={() => {
                    setHotspotSkipTracker(
                      (hotspotSkipTracker) => hotspotSkipTracker + 1
                    )
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}
      <div
        id='parentView'
        style={{
          width: isEmbeded ? '100%' : undefined,
          height: isEmbeded ? '100%' : '90%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          pointerEvents:
            completed === 1 || !isActive || explanationClick ? 'none' : 'auto',
          cursor: 'pointer'
        }}
      >
        <div
          style={{
            margin: 'auto',
            width: Background === '' ? '100%' : 'fit-content',
            height: '100%'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: Background === '' ? '100%' : 'fit-content',
              position: 'relative',
              height: '100%'
            }}
            onClick={(e) => {
              if (!isEmbeded) {
                if (Object.keys(selectionMap).length !== HotSpot.length) {
                  onAttemptChange(1)
                  const obj = {
                    x: e.nativeEvent.offsetX,
                    y: e.nativeEvent.offsetY
                  }
                  let selectionMapCopy = { ...selectionMap }
                  selectionMapCopy[currentHotspot.ID] = obj
                  setSelectionMap(selectionMapCopy)
                  if (isPractice) {
                    handleSuccessChange(false)
                  }
                  updateCurrentHotspot(true, selectionMapCopy)
                }
              }
            }}
          >
            <span
              style={{
                backgroundColor: BackgroundOverlay,
                width: '100%',
                position: 'absolute',
                height: '100%',
                zIndex: 1
              }}
            />
            {Background !== '' && (
              <img
                ref={imgRef}
                alt='sd'
                src={Background}
                style={{
                  margin: 'auto',
                  zIndex: 0,
                  height: '100%',
                  maxWidth: '100%',
                  objectFit: 'fill'
                }}
              />
            )}
            {!isEmbeded && Opacity && (
              <span
                style={{
                  height: '100%',
                  width: '100%',
                  position: 'absolute',
                  backgroundColor: Opacity
                }}
              />
            )}
            {isAnimation && !isEmbeded && (
              <div
                style={{
                  backgroundColor: '#00000080',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'absolute',
                  display: 'flex',
                  flexDirection: 'column',
                  alignSelf: 'center',
                  height: '100%',
                  width: '100%'
                }}
              >
                <Lottie
                  options={defaultOptions}
                  width={200}
                  height={200}
                  isStopped={isStopped}
                />
                <p
                  style={{
                    color: 'white',
                    fontSize: '30px',
                    fontWeight: 'bold'
                  }}
                >
                  Tap on the image to mark a hotspot
                </p>
              </div>
            )}
            {isVerifyMode &&
              hotSpotList.map((h) => {
                if (h.Score > 0) {
                  return (
                    <div
                      key={h.ID}
                      style={{
                        left: h.X.concat('%'),
                        top: h.Y.concat('%'),
                        height: h.Height,
                        width: h.Width,
                        position: 'absolute',
                        display: 'flex'
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          backgroundColor:
                            DisplayType === 'Mark' ? undefined : 'green',
                          borderColor:
                            DisplayType === 'Mark' ? undefined : 'green',
                          borderWidth: DisplayType === 'Mark' ? 0 : '2px',
                          alignItems: 'center',
                          justifyContent: 'center',
                          alignContent: 'center',
                          flexShrink: 1,
                          display: 'flex'
                        }}
                      >
                        {/* mark/rect/both */}
                        {(DisplayType === 'Both' || DisplayType === 'Mark') && (
                          <LocationOnIcon
                            style={{
                              width: '20%',
                              height: '20%',
                              color: 'white',
                              cursor: 'pointer',
                              alignSelf: 'center'
                            }}
                          />
                        )}
                        <p
                          style={{
                            flexShrink: 1,
                            color: AnswerColorFill,
                            fontSize: '10px',
                            margin: 0,
                            zIndex: 2
                          }}
                        >
                          {h.AnswerLabel}
                        </p>
                      </div>
                    </div>
                  )
                }
              })}
            {/* 1 question 1 hotspot and n question n hotspot handling */}
            {IsMultipleQuestion && currentHotspot && !isEmbeded && (
              <div
                onClick={(event) => {
                  event.stopPropagation()
                  onAttemptChange(1)
                  let selectionMapCopy = { ...selectionMap }
                  selectionMapCopy[currentHotspot.ID] = true
                  setSelectionMap(selectionMapCopy)
                  if (isPractice) {
                    handleSuccessChange(true)
                  }
                  updateCurrentHotspot(true, selectionMapCopy)
                }}
                style={{
                  left: currentHotspot.X.concat('%'),
                  top: currentHotspot.Y.concat('%'),
                  height: currentHotspot.Height,
                  width: currentHotspot.Width,
                  position: 'absolute',
                  zIndex: 2
                }}
              />
            )}
            {/* 1 question n hotspot handling */}
            {(!IsMultipleQuestion || isEmbeded) &&
              currentHotspot &&
              hotSpotList.map((h, index) => (
                <div
                  key={index.toString()}
                  onClick={(event) => {
                    let isCorrect = validateCorrectOrNot()
                    if (isPractice && followTheFlow) {
                      if (isCorrect) {
                      } else {
                        event.stopPropagation()
                        onAttemptChange(1)
                        let selectionMapCopy = { ...selectionMap }
                        selectionMapCopy[h.ID] = true
                        setSelectionMap(selectionMapCopy)
                        if (isPractice) {
                          if (isEmbeded) {
                            if (h.Score > 0) {
                              handleSuccessChange(true)
                            } else {
                              handleSuccessChange(false)
                            }
                          } else {
                            handleSuccessChange(true)
                          }
                        }
                        updateCurrentHotspot(true, selectionMapCopy)
                      }
                    } else {
                      event.stopPropagation()
                      onAttemptChange(1)
                      let selectionMapCopy = { ...selectionMap }
                      selectionMapCopy[h.ID] = true
                      setSelectionMap(selectionMapCopy)
                      if (isPractice) {
                        if (isEmbeded) {
                          if (h.Score > 0) {
                            handleSuccessChange(true)
                          } else {
                            handleSuccessChange(false)
                          }
                        } else {
                          handleSuccessChange(true)
                        }
                      }
                      updateCurrentHotspot(true, selectionMapCopy)
                    }
                  }}
                  style={{
                    left: h.X.concat('%'),
                    top: h.Y.concat('%'),
                    height: currentHotspot.Height,
                    width: currentHotspot.Width,
                    position: 'absolute',
                    zIndex: 2
                  }}
                />
              ))}
            {/* to display all selected hotspots */}
            {!isVerifyMode &&
              Object.keys(selectionMap).map((s) => {
                const hotspot = hotSpotList.find((h) => h.ID === s)
                const value = selectionMap[s]

                if (hotspot) {
                  if (value === true) {
                    return (
                      <div
                        key={s}
                        onClick={(event) => {
                          let isCorrect = validateCorrectOrNot()
                          if (isPractice && followTheFlow) {
                            if (isCorrect) {
                            } else {
                              event.stopPropagation()
                              //   onAttemptChange(1);
                              let selectionMapCopy = { ...selectionMap }
                              delete selectionMapCopy[hotspot.ID]
                              setSelectionMap(selectionMapCopy)
                              if (Object.keys(selectionMapCopy).length === 0) {
                                setCurrentHotspot(HotSpot[0])
                                validateCorrectAnswer(
                                  false,
                                  selectionMapCopy,
                                  HotSpot
                                )
                              } else {
                                setCurrentHotspot(hotspot)
                                const remainigHotspots = HotSpot.filter(
                                  (h) =>
                                    !Object.keys(selectionMapCopy).includes(
                                      h.ID
                                    )
                                )
                                validateCorrectAnswer(
                                  false,
                                  selectionMapCopy,
                                  remainigHotspots
                                )
                              }
                            }
                          } else {
                            event.stopPropagation()
                            //   onAttemptChange(1);
                            let selectionMapCopy = { ...selectionMap }
                            delete selectionMapCopy[hotspot.ID]
                            setSelectionMap(selectionMapCopy)
                            if (Object.keys(selectionMapCopy).length === 0) {
                              setCurrentHotspot(HotSpot[0])
                              validateCorrectAnswer(
                                false,
                                selectionMapCopy,
                                HotSpot
                              )
                            } else {
                              setCurrentHotspot(hotspot)
                              const remainigHotspots = HotSpot.filter(
                                (h) =>
                                  !Object.keys(selectionMapCopy).includes(h.ID)
                              )
                              validateCorrectAnswer(
                                false,
                                selectionMapCopy,
                                remainigHotspots
                              )
                            }
                          }
                        }}
                        style={{
                          left: hotspot.X.concat('%'),
                          top: hotspot.Y.concat('%'),
                          height: hotspot.Height,
                          width: hotspot.Width,
                          position: 'absolute',
                          zIndex: 3,
                          display: 'flex'
                        }}
                      >
                        <div
                          className={
                            isPractice || completed === 1 || !isActive
                              ? isEmbeded
                                ? hotspot.Score > 0
                                  ? 'hotspot-container hotspot-container-true'
                                  : 'hotspot-container hotspot-container-false'
                                : 'hotspot-container hotspot-container-true'
                              : 'hotspot-container hotspot-container-test'
                          }
                          style={{
                            animationName:
                              isPractice && completed === 0
                                ? hotspot.Score > 0
                                  ? 'pulse_animation'
                                  : 'shake_animation'
                                : 'zoom-in',
                            animationDuration: '200ms'
                          }}
                        >
                          <div
                            className={
                              isPractice || completed === 1 || !isActive
                                ? isEmbeded
                                  ? hotspot.Score > 0
                                    ? 'hotspot-mark-view hotspot-mark-view-true'
                                    : 'hotspot-mark-view hotspot-mark-view-false'
                                  : 'hotspot-mark-view hotspot-mark-view-true'
                                : 'hotspot-mark-view hotspot-mark-view-test'
                            }
                          >
                            {isPractice || completed === 1 || !isActive ? (
                              isEmbeded ? (
                                hotspot.Score > 0 ? (
                                  <CheckCircleRoundedIcon
                                    style={{
                                      color: '#3EC986'
                                    }}
                                  />
                                ) : (
                                  <CancelRoundedIcon
                                    style={{
                                      color: '#FF551F'
                                    }}
                                  />
                                )
                              ) : (
                                <CheckCircleRoundedIcon
                                  style={{
                                    color: '#3EC986'
                                  }}
                                />
                              )
                            ) : (
                              <div className='hotspot-mark-view-inner' />
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  } else if (value && value.x) {
                    return (
                      <div
                        key={s}
                        style={{
                          left: selectionMap[hotspot.ID].x,
                          top: selectionMap[hotspot.ID].y,
                          height: hotspot.Height,
                          width: hotspot.Width,
                          position: 'absolute',
                          display: 'flex',
                          zIndex: 3
                        }}
                        onClick={(event) => {
                          event.stopPropagation()
                          // onAttemptChange(1);
                          let selectionMapCopy = { ...selectionMap }
                          delete selectionMapCopy[hotspot.ID]
                          setSelectionMap(selectionMapCopy)
                          if (Object.keys(selectionMapCopy).length === 0) {
                            setCurrentHotspot(HotSpot[0])
                            validateCorrectAnswer(
                              false,
                              selectionMapCopy,
                              HotSpot
                            )
                          } else {
                            setCurrentHotspot(hotspot)
                            const remainigHotspots = HotSpot.filter(
                              (h) =>
                                !Object.keys(selectionMapCopy).includes(h.ID)
                            )
                            validateCorrectAnswer(
                              false,
                              selectionMapCopy,
                              remainigHotspots
                            )
                          }
                        }}
                      >
                        <div
                          className={
                            isPractice || completed === 1 || !isActive
                              ? isEmbeded
                                ? hotspot.Score > 0
                                  ? 'hotspot-container hotspot-container-true'
                                  : 'hotspot-container hotspot-container-false'
                                : 'hotspot-container hotspot-container-true'
                              : 'hotspot-container hotspot-container-test'
                          }
                          style={{
                            animationName:
                              isPractice && completed === 0
                                ? hotspot.Score > 0
                                  ? 'pulse_animation'
                                  : 'shake_animation'
                                : 'zoom-in',
                            animationDuration: '200ms'
                          }}
                        >
                          <div
                            className={
                              isPractice || completed === 1 || !isActive
                                ? 'hotspot-mark-view hotspot-mark-view-false'
                                : 'hotspot-mark-view hotspot-mark-view-test'
                            }
                          >
                            {isPractice || completed === 1 || !isActive ? (
                              <CancelRoundedIcon
                                style={{
                                  color: '#FF551F'
                                }}
                              />
                            ) : (
                              <div className='hotspot-mark-view-inner' />
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  }
                }
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HotspotComponent
